import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';
import classNames from 'classnames';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { FloatingBar } from 'ziphy-web-shared/basic/lib/simple';
import { $layouts } from 'ziphy-web-shared/basic/utils/layouts';
import styles from './SignUnsignedChanges.module.scss';
const SignUnsignedChanges = ({ className, onSubmit }) => {
    var _a;
    const { t } = useTranslation();
    const floatBarRef = useRef(null);
    const { ref: inViewRef, inView } = useInView({ initialInView: true });
    const active = true;
    return (_jsxs("div", Object.assign({ ref: inViewRef, className: classNames(styles.wrapper, className) }, { children: [_jsx("div", Object.assign({ className: classNames(styles.error, active && styles.active, className) }, { children: t('label.unsigned_changes_available') })), _jsx(FloatingBar, Object.assign({ ref: floatBarRef, label: t('label.unsigned_changes_available'), bottomOffset: inView ? -(30 + ((_a = floatBarRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight)) : $layouts.marginBottom }, { children: _jsx(Button, Object.assign({ mode: ['primary', 'sm'], onClick: onSubmit }, { children: t('btn.sign_changes') })) }))] })));
};
export default observer(SignUnsignedChanges);
